export const SAVE = 'stepCancellationAdditional.SAVE';
export const VALUE_CHANGED = 'stepCancellationAdditional.VALUE_CHANGED';
export const LOAD = 'stepCancellationAdditional.VALUE_LOAD';
export const NEXT = 'stepCancellationAdditional.NEXT';
export const RESET = 'stepCancellationAdditional.RESET';
export const RESET_TRAVEL_DELAY = 'stepCancellationAdditional.RESET_TRAVEL_DELAY';
export const RESET_CANCELLATION_AMENDMENT = 'stepCancellationAdditional.RESET_CANCELLATION_AMENDMENT';
export const RESET_COMPENSATION = 'stepCancellationAdditional.RESET_COMPENSATION';
export const RESET_ADDITIONAL = 'stepCancellationAdditional.RESET_ADDITIONAL';



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepCancellationAdditional/constants.js